function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Body, Button, FormInput, FormSelect } from "../../../atoms";
import { Modal } from "../../../molecules";
import LegacySimulatorAction from "../LegacySimulatorAction";
var schema = z.object({
    relationship: z.string().min(1),
    name: z.string().optional()
});
export var EBeneficiary;
(function(EBeneficiary) {
    EBeneficiary["IMMEDIATE_FAMILY"] = "immediate-family";
    EBeneficiary["SIBLINGS"] = "siblings";
    EBeneficiary["EXTENDED_FAMILY"] = "extended-family";
    EBeneficiary["OTHERS"] = "others";
})(EBeneficiary || (EBeneficiary = {}));
var options = Object.values(EBeneficiary).map(function(value) {
    return {
        label: value,
        value: value
    };
});
var StepListBeneficiary = function(param) {
    var t = param.t, stepState = param.stepState, beneficiariesState = param.beneficiariesState;
    var _useState = _sliced_to_array(useState(false), 2), openModal = _useState[0], setOpenModal = _useState[1];
    var _beneficiariesState = _sliced_to_array(beneficiariesState, 2), beneficiaries = _beneficiariesState[0], setBeneficiaries = _beneficiariesState[1];
    var _useForm = useForm({
        resolver: zodResolver(schema)
    }), control = _useForm.control, formState = _useForm.formState, watch = _useForm.watch, reset = _useForm.reset, handleSubmit = _useForm.handleSubmit;
    var errors = formState.errors;
    var values = watch();
    var onOpenModal = function() {
        setOpenModal(true);
    };
    var onCloseModal = function() {
        reset();
        setOpenModal(false);
    };
    var handleSuccess = function(formValues) {
        var lastId = 1;
        if (beneficiaries.length) {
            lastId = beneficiaries[beneficiaries.length - 1].id + 1;
        }
        setBeneficiaries(_to_consumable_array(beneficiaries).concat([
            {
                id: lastId,
                name: formValues.name,
                relationship: formValues.relationship
            }
        ]));
        reset();
        onCloseModal();
    };
    var onRemoveBeneficiary = function(id) {
        setBeneficiaries(beneficiaries.filter(function(beneficiary) {
            return beneficiary.id !== id;
        }));
    };
    var canAdd = useMemo(function() {
        return !!values.relationship;
    }, [
        values
    ]);
    var canContinue = useMemo(function() {
        return beneficiaries.length > 0;
    }, [
        beneficiaries
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center justify-center w-full h-auto gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap items-center justify-center w-full gap-8 mt-6 mb-7"
    }, beneficiaries.map(function(beneficiary) {
        return /*#__PURE__*/ React.createElement("div", {
            key: beneficiary.id,
            className: "relative flex flex-col items-center justify-center px-4 py-0 bg-white rounded-md w-30 h-30"
        }, /*#__PURE__*/ React.createElement("button", {
            type: "button",
            className: "absolute top-2 right-2 w-5.5 h-5.5 flex justify-center items-center bg-red-500 text-white rounded-full",
            onClick: function() {
                return onRemoveBeneficiary(beneficiary.id);
            }
        }, "-"), /*#__PURE__*/ React.createElement(Body, {
            as: "p",
            variant: "sm",
            className: "mb-2 font-semibold font-heading"
        }, t(beneficiary.relationship)), /*#__PURE__*/ React.createElement(Body, {
            as: "span",
            className: "font-semibold opacity-50 font-heading text-body-xSmall"
        }, beneficiary.name));
    }), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "flex items-center justify-center text-white bg-red-500 rounded-full w-27 h-27 text-body-xlarge",
        onClick: onOpenModal
    }, "+")), /*#__PURE__*/ React.createElement(LegacySimulatorAction, {
        t: t,
        stepState: stepState,
        canContinue: canContinue
    }), /*#__PURE__*/ React.createElement(Modal, {
        open: openModal,
        onClose: onCloseModal,
        noCloseButton: true,
        className: "!w-110 max-w-full bg-white !p-8",
        contentClassName: "flex flex-col gap-7"
    }, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-center text-body-large font-heading"
    }, t("add-a-beneficiary")), /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit(handleSuccess),
        className: "flex flex-col gap-7"
    }, /*#__PURE__*/ React.createElement(Controller, {
        name: "relationship",
        control: control,
        render: function(param) {
            var _param_field = param.field, value = _param_field.value, onChange = _param_field.onChange;
            var _errors_relationship;
            return /*#__PURE__*/ React.createElement(FormSelect, {
                label: t("indicate-your-relationship"),
                required: true,
                options: options.map(function(option) {
                    return {
                        label: t(option.label),
                        value: option.value
                    };
                }),
                value: value,
                onChange: onChange,
                error: (_errors_relationship = errors.relationship) === null || _errors_relationship === void 0 ? void 0 : _errors_relationship.message
            });
        }
    }), /*#__PURE__*/ React.createElement(Controller, {
        name: "name",
        control: control,
        render: function(param) {
            var _param_field = param.field, value = _param_field.value, onChange = _param_field.onChange;
            var _errors_name;
            return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
                as: "p",
                variant: "sm",
                className: "mb-4 font-semibold font-heading"
            }, t("name-of-beneficiary"), " (", t("optional"), ")"), /*#__PURE__*/ React.createElement(FormInput, {
                value: value,
                onChange: onChange,
                error: (_errors_name = errors.name) === null || _errors_name === void 0 ? void 0 : _errors_name.message,
                inputClasses: "border-neutral-900 border-opacity-50 py-6 px-5 font-semibold"
            }));
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-3"
    }, /*#__PURE__*/ React.createElement(Button, {
        htmlType: "submit",
        className: "w-full",
        disabled: !canAdd
    }, t("add")), /*#__PURE__*/ React.createElement(Button, {
        variant: "secondary",
        className: "text-red-500",
        onClick: onCloseModal
    }, t("cancel"))))));
};
export default StepListBeneficiary;

//# sourceMappingURL=StepListBeneficiary.js.map